import React from "react";
import DriverInsuranceLogo from "./DriverInsuranceLogo";

const Navbar = () => (
  <header className="tw-bg-dis-navy tw-text-white">
    <div className="tw-mx-auto tw-flex tw-max-w-[1200px] tw-items-center tw-justify-between tw-gap-3 tw-px-[clamp(16px,4vw,40px)] tw-py-3.5">
      <DriverInsuranceLogo />
    </div>
  </header>
);

export default Navbar;
